import { atom } from 'jotai'

import { draggingMultipleShipmentOrdersAtom } from './dragging-multiple-shipment-orders.atom'
import { draggingShipmentOrderAtom } from './dragging-shipment-order.atom'

/**
 * 掴んでいるのが配車済みの依頼（単体カード / 全件配車済みの束ねカード）か（#4488 VOC_PJ-948）。
 * 板側の着地計算・ドロップ確定の素通りと、オーバーレイの「置けない」表示が同じ判定を見る。
 * 判定を 1 か所に置くことで、掴める配車済みの種類を増やしたときに片方だけ漏れて
 * 「板は無反応なのにカーソルは掴めそう」のような食い違いが起きないようにする
 */
export const isDraggingDispatchedAtom = atom(
  (get) =>
    get(draggingShipmentOrderAtom)?.isDispatched === true ||
    get(draggingMultipleShipmentOrdersAtom)?.isDispatched === true
)

isDraggingDispatchedAtom.debugLabel = 'isDraggingDispatchedAtom'
